import { render, staticRenderFns } from "./ShipmentPrototypePaymentList.vue?vue&type=template&id=358d39e1&scoped=true"
import script from "./ShipmentPrototypePaymentList.vue?vue&type=script&lang=js"
export * from "./ShipmentPrototypePaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358d39e1",
  null
  
)

export default component.exports